import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Store from "@material-ui/icons/Store";
import PeopleIcon from "@material-ui/icons/People";
import ListAlt from "@material-ui/icons/ListAlt";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import MoneyIcon from "@material-ui/icons/Money"
import { bindActionCreators } from "redux";
import {
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@material-ui/core";
import { Creators as HeaderActions } from "../../store/ducks/header";
import { menuDashStyle } from "./menuDashStyle";
import { NavLink } from "react-router-dom";
import { ADMIN_UID } from "../../utils/js/constants";

const useStyles = makeStyles((theme) => menuDashStyle(theme));

const MenuDash = ({ toggle, header }) => {
    const classes = useStyles();
    const { open } = header;

    const user = JSON.parse(sessionStorage.getItem("user"))
    const isAdmin = user?.uid === ADMIN_UID;

    return (
      <Drawer
        variant="permanent"
        classes={{
            paper: clsx(
              classes.drawerPaper,
              open && classes.drawerPaperClose
            ),
        }}
        open={open}
      >
          <div className={classes.toolbarIcon}>
              <IconButton onClick={() => toggle()}>
                  <ChevronLeftIcon
                    style={{ color: "rgba(255, 255, 255, 0.65)" }}
                  />
              </IconButton>
          </div>
          <Divider />
          <List>
              <ListItem button>
                  <NavLink className={classes.navLink}  to="/dashboard">
                      <ListItemIcon className={classes.icons}>
                          <DashboardIcon className={classes.iconColor} />
                      </ListItemIcon>
                      <ListItemText primary="Dashboard" className={classes.itemMenuColor} />
                  </NavLink>
              </ListItem>
              <ListItem button>
                  <NavLink className={classes.navLink} to="/products">
                      <ListItemIcon className={classes.icons}>
                          <ShoppingCartIcon className={classes.iconColor} />
                      </ListItemIcon>
                      <ListItemText primary="Produtos" className={classes.itemMenuColor} />
                  </NavLink>
              </ListItem>
              <ListItem button>
                  <NavLink className={classes.navLink}  to="/stock">
                      <ListItemIcon className={classes.icons}>
                          <ListAlt className={classes.iconColor} />
                      </ListItemIcon>
                      <ListItemText primary="Estoque" className={classes.itemMenuColor} />
                  </NavLink>
              </ListItem>
              <ListItem button>
                  <NavLink className={classes.navLink}  to="/provider">
                      <ListItemIcon className={classes.icons}>
                          <Store className={classes.iconColor} />
                      </ListItemIcon>
                      <ListItemText primary="Fornecedor" className={classes.itemMenuColor} />
                  </NavLink>
              </ListItem>
              <ListItem button>
                  <NavLink className={classes.navLink}  to="/balance">
                      <ListItemIcon className={classes.icons}>
                          <MoneyIcon className={classes.iconColor} />
                      </ListItemIcon>
                      <ListItemText primary="Balanço Patrimonial" className={classes.itemMenuColor} />
                  </NavLink>
              </ListItem>

              {isAdmin ? (
                <ListItem button>
                    <NavLink className={classes.navLink}  to="/users">
                        <ListItemIcon className={classes.icons}>
                            <PeopleIcon className={classes.iconColor} />
                        </ListItemIcon>
                        <ListItemText primary="Usuários" className={classes.itemMenuColor} />
                    </NavLink>
                </ListItem>
              ) : (
                <div/>
              )}
          </List>
          <Divider />
      </Drawer>
    );
};

const mapStatetoProps = (state) => ({ ...state });
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(HeaderActions, dispatch);
};

export default connect(mapStatetoProps, mapDispatchToProps)(MenuDash);
